import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/accessibility")({
  head: () => ({
    meta: [
      { title: "Accessibility Statement · Buddha KA" },
      { name: "description", content: "Our commitment to making buddhaka.com accessible to everyone." },
      { property: "og:title", content: "Accessibility Statement · Buddha KA" },
      { property: "og:description", content: "Accessibility of buddhaka.com." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://buddhaka.com/accessibility" },
      { property: "og:site_name", content: "Buddha KA · KAfrequency" },
    ],
    links: [{ rel: "canonical", href: "https://buddhaka.com/accessibility" }],
  }),
  component: AccessibilityPage,
});

function AccessibilityPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Legal</p>
      <h1 className="mt-4 font-serif text-5xl">Accessibility Statement</h1>
      <p className="mt-3 text-xs text-muted-foreground">Last updated: July 15, 2026</p>

      <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <p>Buddha KA and KAfrequency are committed to making buddhaka.com usable by everyone, including people who rely on assistive technology.</p>

        <h2 className="font-serif text-2xl text-foreground">Standards</h2>
        <p>We aim to meet the Web Content Accessibility Guidelines (WCAG) 2.2 Level AA. This is an ongoing effort — the site is continuously reviewed and improved.</p>

        <h2 className="font-serif text-2xl text-foreground">What we do</h2>
        <ul className="list-disc space-y-1 pl-6">
          <li>Semantic HTML with a single <code>&lt;main&gt;</code> landmark per page and a clear heading hierarchy.</li>
          <li>Keyboard navigation for all interactive elements.</li>
          <li>Descriptive alternative text on meaningful images.</li>
          <li>ARIA labels on icon-only controls.</li>
          <li>Color contrast that meets or exceeds WCAG AA.</li>
          <li>Visible focus states on links and buttons.</li>
        </ul>

        <h2 className="font-serif text-2xl text-foreground">Known limitations</h2>
        <p>Some third-party embeds (streaming players, checkout iframes) may not fully match our accessibility level. We flag these to the vendors and work around them where possible.</p>

        <h2 className="font-serif text-2xl text-foreground">Feedback</h2>
        <p>If something on this site is difficult to use with assistive technology, email <a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a> and describe what you experienced. We take these reports seriously and will respond within a reasonable timeframe.</p>
      </div>
    </div>
  );
}
